// removed by extract-text-webpack-plugin
module.exports = {"container":"_bnf5SegLY0n6-yBhQsW4","spinner":"_myf7gi5rFYN-FpiLzbET"};


//////////////////
// WEBPACK FOOTER
// ./src/common/spinner/Spinner.css
// module id = 364
// module chunks = 0 1 2